import { useStaffUsersListQuery } from 'core/graphql';

export interface IStaffUser {
  id: string;
  name: string;
  email: string;
}

interface IUseStaffUsers {
  staffUsers: IStaffUser[];
  loading: boolean;
}

/**
 * Active ERP staff (management roles) for assignee pickers — task create
 * forms and the "task from message" dialog. Backend filters to staff only, so
 * students/teachers can never be picked as assignees.
 */
export const useStaffUsers = (skip = false): IUseStaffUsers => {
  // errorPolicy:'all' so a PermissionDenied degrades to an empty picker.
  const { data, loading } = useStaffUsersListQuery({
    skip,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });
  return {
    staffUsers: (data?.staffUsers || []) as IStaffUser[],
    loading,
  };
};
